import { useQuery } from 'react-query';
import { logbook } from '../../../API/TT_ELD/logbook';
import { dailies } from '../../../API/TT_ELD/daily';
import { TableParams } from '../../../Utils/TableTypes';

export const useLogBook = (
  companyId: string | number | undefined,
  active: string,
  tableParams: TableParams,
) => {
  return useQuery(
    [`logbook/${companyId}`, companyId, active, tableParams],
    () => logbook.read(companyId, active, tableParams),
    { refetchOnWindowFocus: false },
  );
};
export const useAssignLogBook = (name: string | number | undefined): object => {
  return useQuery([`assign_logbook/${name}`, name], () => logbook.assignLogBook(name), {
    refetchOnWindowFocus: false,
  });
};
export const useAssignUser = (name: any): object => {
  return useQuery([`assign_logbook_user/${name}`, name], () => dailies.driverFinderUser(name, ''), {
    refetchOnWindowFocus: false,
  });
};
export const useLogBookOne = (id: string | undefined) => {
  return useQuery([`logbook_one/${id}`, id], () => logbook.logbookFind(id), {
    refetchOnWindowFocus: false,
  });
};

///driverFinderUser
